class SmoothScrollClass {
  init() {
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener("click", (e) => {
        e.preventDefault();

        const targetElement = this.findTarget(anchor.getAttribute("href"));

        if (targetElement) {
          window.scrollTo({
            top: this.getTargetPosition(targetElement),
            behavior: "smooth",
          });
        }
      });
    });

    this.scrollToHash();
  }

  findTarget(hash) {
    if (!hash || hash.length < 2) return null;

    try {
      return document.querySelector(hash);
    } catch {
      return null; // некорректный селектор в хеше
    }
  }

  getTargetPosition(targetElement) {
    const headerHeight =
      document.querySelector("header")?.offsetHeight || 80;

    return (
      targetElement.getBoundingClientRect().top +
      window.pageYOffset -
      headerHeight -
      20
    );
  }

  scrollToHash() {
    const targetElement = this.findTarget(window.location.hash);
    if (!targetElement) return;

    const scrollToTarget = () => {
      window.scrollTo({
        top: this.getTargetPosition(targetElement),
        behavior: "instant",
      });
    };

    scrollToTarget();

    if (document.readyState !== "complete") {
      window.addEventListener("load", scrollToTarget, { once: true });
    }
  }
}

export const smoothScroll = new SmoothScrollClass();
